import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.updatePassword = this.updatePassword.bind(this);
        this.oldpasswordChange = this.oldpasswordChange.bind(this);
        this.newpasswordChange = this.newpasswordChange.bind(this);
        this.confirmPasswordChange = this.confirmPasswordChange.bind(this);
        this.updatetPassword = this.updatetPassword.bind(this);
        this.oldtpasswordChange = this.oldtpasswordChange.bind(this);
        this.newtpasswordChange = this.newtpasswordChange.bind(this);
        this.confirmtPasswordChange = this.confirmtPasswordChange.bind(this);
        this.settPassword = this.settPassword.bind(this);
        this.state = {
            oldpassword: "",
            newpassword: "",
            confirmPassword: "",
            oldtpassword: "",
            newtpassword: "",
            confirmtPassword: "",
            tpasswordsetted: false
        }
    }
    componentDidMount() {
        this.getProfileDetails();
    }
    oldpasswordChange(event) {
        this.setState({ oldpassword: event.target.value });
    }
    newpasswordChange(event) {
        this.setState({ newpassword: event.target.value });
    }
    confirmPasswordChange(event) {
        this.setState({ confirmPassword: event.target.value });
    }
    oldtpasswordChange(event) {
        this.setState({ oldtpassword: event.target.value });
    }
    newtpasswordChange(event) {
        this.setState({ newtpassword: event.target.value });
    }
    confirmtPasswordChange(event) {
        this.setState({ confirmtPassword: event.target.value });
    }
    validate() {
        let isValid = false;
        if (!this.state.oldpassword) {
            toast("Enter valid old password");
        } else if (!this.state.newpassword) {
            toast("Enter the new password");
        } else if (!this.state.confirmPassword) {
            toast("Enter the confirm password");
        } else if (this.state.newpassword !== this.state.confirmPassword) {
            toast("Password mismatched");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    tvalidate() {
        let isValid = false;
        if (!this.state.oldtpassword) {
            toast("Enter valid old transaction password");
        } else if (!this.state.newtpassword) {
            toast("Enter the new transaction password");
        } else if (!this.state.confirmtPassword) {
            toast("Enter the confirm transaction password");
        } else if (this.state.newtpassword !== this.state.confirmtPassword) {
            toast("Transaction Password mismatched");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    async updatePassword() {
        if (!this.validate()) {
            return;
        }
        let json = {
            oldpassword: this.state.oldpassword,
            newpassword: this.state.newpassword
        }
        let res = await GetORPostAsync("ChangePassword.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.setState({
            oldpassword: "",
            newpassword: "",
            confirmPassword: ""
        });
    }
    async updatetPassword() {
        if (!this.tvalidate()) {
            return;
        }
        let json = {
            oldtpassword: this.state.oldtpassword,
            newtpassword: this.state.newtpassword,
            oldpassword: this.state.oldtpassword,
            newpassword: this.state.newtpassword
        }
        let res = await GetORPostAsync("ChangetPassword.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.setState({
            oldtpassword: "",
            newtpassword: "",
            confirmtPassword: ""
        });
    }
    async settPassword() {
        if (!this.state.newtpassword) {
            toast.error("Enter valid transaction password");
            return;
        }else if (!this.state.confirmtPassword) {
            toast.error("Enter valid confirm transaction password");
            return;
        }else if (this.state.newtpassword !== this.state.confirmtPassword) {
            toast.error("Transaction password mismatched");
            return;
        }
        let json = {
            tpassword: this.state.newtpassword,
            password: this.state.newtpassword,
            confirmpassword: this.state.newtpassword,
            confirmtpassword: this.state.newtpassword
        }
        let res = await GetORPostAsync("SetTransactionPassword.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.setState({
            newtpassword: "",
            confirmtPassword: ""
        });
        this.getProfileDetails();
    }
    async getProfileDetails() {
        let res = await GetORPostAsync("MyProfile.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        this.setState({
            tpasswordsetted: res.tpasswordstatus
        });
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Change Password</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card col-xl-6 col-lg-6 col-md-6 col-xm-12">
                        <div className="card-body  border-1 justify-content-center">
                            <h5 className="text-center mt-3 mb-3">Change Password</h5>
                            <div className="search-element row mt-5 mb-5">
                                <div className="input-container">
                                    <i className="las la-lock inputicon"></i>
                                    <input type="text" className="form-control" placeholder="Old password" value={this.state.oldpassword} onChange={this.oldpasswordChange} aria-label="Old password" tabIndex="1" />
                                </div>
                            </div>
                            <div className="search-element row mb-5">
                                <div className="input-container">
                                    <i className="las la-lock inputicon"></i>
                                    <input type="text" className="form-control" placeholder="New password" value={this.state.newpassword} onChange={this.newpasswordChange} aria-label="New password" tabIndex="1" />
                                </div>
                            </div>
                            <div className="search-element row mb-5">
                                <div className="input-container">
                                    <i className="las la-lock inputicon"></i>
                                    <input type="text" className="form-control" placeholder="Confirm new password" value={this.state.confirmPassword} onChange={this.confirmPasswordChange} aria-label="Confirm new password" tabIndex="1" />
                                </div>
                            </div>
                            <button className="ml-2 mb-5 btn btn-color-1 w-100" onClick={this.updatePassword}>Update</button>
                        </div>
                    </div>
                    <div className="card overflow-hidden dash1-card  col-xl-6 col-lg-6 col-md-6 col-xm-12">
                        <div className="card-body border-1 justify-content-center">
                            <h5 className="text-center mt-3 mb-3">{this.state.tpasswordsetted ? "Change" : "Set"} Transaction Password</h5>
                            {
                                this.state.tpasswordsetted ? <div className="search-element row mt-5 mb-5">
                                    <div className="input-container">
                                        <i className="las la-lock inputicon"></i>
                                        <input type="text" className="form-control" placeholder="Old transaction password" value={this.state.oldtpassword} onChange={this.oldtpasswordChange} aria-label="Old password" tabIndex="1" />
                                    </div>
                                </div> : <></>
                            }
                            <div className="search-element row mb-5">
                                <div className="input-container">
                                    <i className="las la-lock inputicon"></i>
                                    <input type="text" className="form-control" placeholder="New transaction password" value={this.state.newtpassword} onChange={this.newtpasswordChange} aria-label="New password" tabIndex="1" />
                                </div>
                            </div>
                            <div className="search-element row mb-5">
                                <div className="input-container">
                                    <i className="las la-lock inputicon"></i>
                                    <input type="text" className="form-control" placeholder="Confirm new transaction password" value={this.state.confirmtPassword} onChange={this.confirmtPasswordChange} aria-label="Confirm new password" tabIndex="1" />
                                </div>
                            </div>
                            <button className="ml-2 mt-auto mb-5 btn btn-color-1 w-100" onClick={this.state.tpasswordsetted ? this.updatetPassword : this.settPassword}>Update</button>
                        </div>
                    </div>
            </div>
        </div>
        );
    }
}

export default withRouter(ChangePassword);